module.exports = __webpack_public_path__ + "static/media/012_magao.1a962f18.gif";